import { render, staticRenderFns } from "./VisitedUrlModal.vue?vue&type=template&id=3615f8f5&"
import script from "./VisitedUrlModal.vue?vue&type=script&lang=js&"
export * from "./VisitedUrlModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports